import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchSiteContentServer, fetchActiveInsightsServer } from '../lib/serverDataFetchers'
import Hero from '../components/ui/Hero'
import Approach from '../components/ui/Approach'
import About from '../components/ui/About'
import { LazyInsights } from '../components/LazyComponents'
import Testimonials from '../components/ui/Testimonials'
import Service from '../components/ui/Service'
import Contact from '../components/ui/Contact'

export default function Home() {
  // Fetch site content using React Query
  const { data: siteContent } = useQuery({
    queryKey: ['site-content'],
    queryFn: fetchSiteContentServer,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  })

  // Fetch insights using React Query (pre-fetched for LazyInsights component)
  useQuery({
    queryKey: ['insights', 'active'],
    queryFn: fetchActiveInsightsServer,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  })

  // Update document title for this page
  useEffect(() => {
    document.title = "KES Global Advisors LLC | Unlocking Your Organization's Full Potential"

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content',
        "By engaging, aligning, and empowering your workforce, KES Global Advisors can help unlock your organization's full potential to drive sustainable improvements for your business."
      )
    }
  }, [])

  return (
    <>
      <Hero content={siteContent} />
      <Testimonials />
      <Approach content={siteContent} />
      <Service />
      <About content={siteContent} />
      <LazyInsights />
      <Contact />
    </>
  )
}
